export default __webpack_public_path__ + "media/custom-branding2x.78088c24.png";